export enum AuthPlatform {
    Native = "Native",
    Facebook = "Facebook",
    All = "All"
}
